import { UniQActions } from "us.common/constants";
import { initialState } from "./State";

const {
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  RESET_MESSAGE,
  SET_MESSAGES,
  RESET_MESSAGES,
  CLEAR_MESSAGES,
  HANDLE_SETTINGS_POPOVER,
  SAVE_DEFAULT_PROMPT,
  SAVE_DEFAULT_PROMPT_SUCCESS,
  SAVE_DEFAULT_PROMPT_FAIL,
  GET_DEFAULT_PROMPT,
  GET_DEFAULT_PROMPT_SUCCESS,
  GET_DEFAULT_PROMPT_FAIL,
  RESET_DEFAULT_PROMPT_DATA,
  RESET_SESSION,
  RESET_SESSION_SUCCESS,
  RESET_SESSION_FAIL,
} = UniQActions;

export default (state = initialState, action: any) => {
  switch (action.type) {
    case SEND_MESSAGE:
      return Object.assign({}, state, {
        newMessage: {
          data: action.payload.data,
          isLoading: true,
        },
        messages: {
          data: [...state.messages.data, action.payload.data],
          isLoading: true,
        },
      });
    case SEND_MESSAGE_SUCCESS:
      return Object.assign({}, state, {
        newMessage: {
          data: action.payload.data,
          isLoading: false,
        },
        messages: {
          data: [...state.messages.data, action.payload.data],
          isLoading: false,
        },
      });
    case SEND_MESSAGE_FAIL:
      return Object.assign({}, state, {
        newMessage: {
          data: action.payload.data,
          isLoading: false,
        },
      });
    case RESET_MESSAGE:
      return Object.assign({}, state, {
        newMessage: {
          data: null,
          isLoading: false,
        },
      });
    case RESET_MESSAGES:
      return Object.assign({}, state, {
        messages: {
          data: [],
          isLoading: false,
        },
        defaultPrompt: initialState.defaultPrompt,
      });
    case SET_MESSAGES:
      return Object.assign({}, state, {
        messages: {
          data: action.payload.data,
          isLoading: true,
        },
      });
    case HANDLE_SETTINGS_POPOVER:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isVisible: !state.defaultPrompt.isVisible,
        },
      });
    case SAVE_DEFAULT_PROMPT:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isSaving: true,
        },
      });
    case SAVE_DEFAULT_PROMPT_SUCCESS:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isVisible: false,
          isSaving: false,
          data: {
            ...state.defaultPrompt.data,
            executedUserPrompt: action.payload.data.userAIPrompt,
          },
        },
      });
    case SAVE_DEFAULT_PROMPT_FAIL:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isVisible: false,
          isSaving: false,
        },
      });
    case GET_DEFAULT_PROMPT:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isFetching: true,
        },
      });
    case GET_DEFAULT_PROMPT_SUCCESS:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isVisible: false,
          isFetching: false,
          data: action.payload.data,
        },
      });
    case GET_DEFAULT_PROMPT_FAIL:
      return Object.assign({}, state, {
        defaultPrompt: {
          ...state.defaultPrompt,
          isFetching: false,
        },
      });
    case RESET_DEFAULT_PROMPT_DATA:
      return Object.assign({}, state, {
        defaultPrompt: initialState.defaultPrompt,
      });
    case CLEAR_MESSAGES:
      return Object.assign({}, state, {
        messages: {
          data: [],
          isLoading: false,
        },
      });
    case RESET_SESSION:
      return Object.assign({}, state, {
        sessionReset: {
          data: action.payload.data,
          isLoading: true,
          isSuccess: false,
        },
      });
    case RESET_SESSION_SUCCESS:
      return Object.assign({}, state, {
        sessionReset: {
          data: action.payload.data,
          isLoading: false,
          isSuccess: true,
        },
      });
    case RESET_SESSION_FAIL:
      return Object.assign({}, state, {
        sessionReset: {
          data: action.payload.error,
          isLoading: false,
          isSuccess: false,
        },
      });
    default:
      return state;
  }
};
